<section class="package-type-selector" aria-labelledby="package-type-heading">
  <div class="package-type-selector__header">
    <puro-typography id="package-type-heading" variant="h2" component="h2">
      {{ 'createShipment.packageStep.selectTitle' | translate }}
    </puro-typography>
    <p class="package-type-selector__legend">
      <span class="package-type-selector__required" aria-hidden="true">*</span
      >{{ 'createShipment.packageStep.requiredLegend' | translate }}
    </p>
  </div>

  <fieldset class="package-type-selector__list" aria-labelledby="package-type-heading">
    @for (type of packageTypes(); track type.id) {
      <div
        class="package-type-selector__card"
        [class.package-type-selector__card--selected]="selectedId() === type.id"
        [class.package-type-selector__card--expanded]="selectedId() === type.id"
      >
        <div class="package-type-selector__card-main">
          <label class="package-type-selector__radio-row">
            <input
              class="package-type-selector__native-radio"
              type="radio"
              name="packageType"
              [value]="type.id"
              [checked]="selectedId() === type.id"
              (change)="onSelect(type.id)"
            />
            <span
              class="package-type-selector__radio"
              [class.package-type-selector__radio--checked]="selectedId() === type.id"
              aria-hidden="true"
            ></span>
            <span class="package-type-selector__copy">
              <span class="package-type-selector__label-row">
                <span class="package-type-selector__label">{{ type.label }}</span>
                @if (type.tooltipKey) {
                  <puro-tooltip #typeTooltip [content]="type.tooltipKey | translate">
                    <button
                      type="button"
                      class="package-type-selector__tooltip-trigger"
                      [attr.aria-label]="type.tooltipKey | translate"
                      (click)="$event.preventDefault(); $event.stopPropagation()"
                      (focus)="typeTooltip.show()"
                      (blur)="typeTooltip.hide()"
                    >
                      <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
                    </button>
                  </puro-tooltip>
                }
              </span>
              @if (type.dimensions) {
                <span class="package-type-selector__subtitle">{{ type.dimensions }}</span>
              } @else if (type.subtitleKey) {
                <span class="package-type-selector__subtitle">{{
                  type.subtitleKey | translate
                }}</span>
              }
            </span>
          </label>

          <div class="package-type-selector__aside">
            @if (type.requiresDimensions) {
              <button
                type="button"
                class="package-type-selector__measure-link"
                (click)="onHowToMeasure($event)"
              >
                {{ 'createShipment.packageStep.howToMeasure' | translate }}
              </button>
            } @else if (type.idealFor?.length) {
              <div class="package-type-selector__ideal">
                <p class="package-type-selector__ideal-title">
                  {{ 'createShipment.packageStep.idealFor' | translate }}
                </p>
                <ul>
                  @for (ideal of type.idealFor; track ideal) {
                    <li>{{ ideal }}</li>
                  }
                </ul>
              </div>
            }
            <span class="package-type-selector__image-wrap" aria-hidden="true">
              <img
                class="package-type-selector__image"
                [src]="type.imageAssetPath"
                alt=""
                width="116"
                height="86"
              />
            </span>
          </div>
        </div>

        @if (selectedId() === type.id) {
          <div class="package-type-selector__card-details">
            <ng-content select="[packageDetailsSlot]" />
          </div>
        }
      </div>
    }
  </fieldset>
</section>
